import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import WhyDoYouNeed from './components/WhyDoYouNeed'
import CDPFeatures from './components/CdpFeatures'
import Octopus from './components/Octopus'
import TwilioSegmentDifferences from './components/TwilioSegmentDifferences'
import TwilioSegmentRanked from './components/TwilioSegmentRanked'

import OgSegmentVsMparticle from './assets/OgSegmentVsMparticle.png'
import OgSegmentVsOtherCdps from './assets/OgSegmentVsOtherCdps.png'

type ogImage = `ogSegmentVsMparticle` | `ogSegmentVsOtherCdps`

const OgList = {
  ogSegmentVsMparticle: OgSegmentVsMparticle,
  ogSegmentVsOtherCdps: OgSegmentVsOtherCdps,
}

export interface CompetitorViewProps {
  metadata: {
    title: string
    description: string
    ogImage: ogImage
    pageRobotsDirective?: string
    canonicalUrl?: string
  }
  hero: {
    heading: string
    copy: {
      paragraph: string
    }[]
    formId: string
  }
  whyDoYouNeed: {
    heading: string
    copy: {
      paragraph: string
    }[]
  }
  cdpFeatures: {
    heading?: string
    features: {
      heading: string
      copy: {
        paragraph: string
      }[]
    }[]
  }
  twilioSegmentDifferences: {
    heading: string
    features: {
      heading: string
      copy: string[]
    }[]
  }
  twilioSegmentRanked: {
    heading: string
    features: {
      heading: string
      copy: {
        paragraph: string
      }[]
    }[]
    showDisclaimer: boolean
  }
}

const CompetitorView: FC<CompetitorViewProps> = (props) => {
  const { metadata, hero, whyDoYouNeed, cdpFeatures, twilioSegmentDifferences, twilioSegmentRanked } = props

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={metadata.title}
        pageDescription={metadata.description}
        pageOG={OgList[metadata.ogImage]}
        pageRobotsDirective={metadata.pageRobotsDirective}
        canonicalUrl={metadata.canonicalUrl}
      >
        <Navigation />
        <Hero {...hero} />
        <LogoCarousel />
        <WhyDoYouNeed {...whyDoYouNeed} />
        <CDPFeatures {...cdpFeatures} />
        <Octopus />
        <TwilioSegmentDifferences {...twilioSegmentDifferences} />
        <TwilioSegmentRanked {...twilioSegmentRanked} />
        <GettingStarted />
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

export default CompetitorView
